import styled, { css } from 'styled-components';

import {
    Button,
    Card,
    mediaMixin,
    spaceMixin,
} from '@zillow/constellation';

import {
    Row,
} from '@zillow/zrs-comet';

export const StyledDivContainer = styled.div`
    ${mediaMixin('lg', css`
        padding-left: ${spaceMixin('md')};
    `)}
`;

export const StyledHeadingLink = styled.span`
    float: right;
`;

export const StyledSpinnerCard = styled(Card)`
    height: 300px;
`;

export const StyledButton = styled(Button)`
    float: right;
    width: 100%;

    ${mediaMixin('lg', css`
        width: auto;
    `)}
`;

export const StyledRowApplicationCardsContainer = styled(Row)`
    min-height: 320px;
`;
